import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import { AuthResponse } from '../interfaces/auth.interface';
import { 
  Product, 
  CreateProductRequest, 
  UpdateProductRequest 
} from '../interfaces/product.interface';
import { API_ENDPOINTS } from '../constants/api.constants';

/**
 * Service for product management operations
 */
@Injectable({
  providedIn: 'root'
})
export class ProductsService extends BaseHttpService {

  /**
   * Gets products by insurance company
   */
  getProductsByCompany(companyId: number): Observable<Product[]> {
    if (!this.hasValidToken()) {
      return this.returnEmptyArrayWhenNoToken<Product>();
    }

    const endpoint = `${API_ENDPOINTS.AUTH.PRODUCTS}/company/${companyId}`;
    return this.get<Product[]>(endpoint);
  }

  /**
   * Creates a new product
   */
  createProduct(productData: CreateProductRequest): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }

    return this.post<AuthResponse>(`${API_ENDPOINTS.AUTH.PRODUCTS}/`, productData);
  }

  /**
   * Updates an existing product
   */
  updateProduct(productId: number, productData: UpdateProductRequest): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }

    const endpoint = `${API_ENDPOINTS.AUTH.PRODUCTS}/${productId}`;
    return this.put<AuthResponse>(endpoint, productData);
  }

  /**
   * Deletes a product
   */
  deleteProduct(productId: number): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return throwError(() => new Error('Nincs érvényes token'));
    }

    const endpoint = `${API_ENDPOINTS.AUTH.PRODUCTS}/${productId}`;
    return this.delete<AuthResponse>(endpoint);
  }
}